module.exports = __webpack_public_path__ + "assets/img/2021activity-detail-close.0fc9c86a.png";